import {
  HTTP_RESPONSE_NOT_FOUND,
  HTTP_RESPONSE_FORBIDDEN,
  HTTP_RESPONSE_INTERNAL_SERVER_ERROR,
  HTTP_RESPONSE_UNAUTHORIZED,
  HTTP_RESPONSE_GENERIC_ERROR,
} from "../actions/httpInterceptActions";

const initialState = { error: null };

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case HTTP_RESPONSE_UNAUTHORIZED:
    case HTTP_RESPONSE_NOT_FOUND:
    case HTTP_RESPONSE_FORBIDDEN:
    case HTTP_RESPONSE_INTERNAL_SERVER_ERROR:
    case HTTP_RESPONSE_GENERIC_ERROR:
      return { ...state, error: action.payload };
    default:
      return state; // return previous state
  }
};



// WEBPACK FOOTER //
// ./reducers/httpInterceptReducer.jsx